<ion-header class="ion-no-border ion-no-margin ion-padding-start ion-padding-top">
  <ion-item lines="none" class="ion-no-padding">
    <div class="ion-text-center">
      <usucampeao-usuario-avatar [src]="userPhoto | async" large="medium"></usucampeao-usuario-avatar>
      <div *ngIf="editOption === true" class="font-text">
        <ion-text color="secondary" (click)="navigateToEditPhoto()"><strong>Trocar foto</strong></ion-text>
      </div>
    </div>
    <ion-label>
      <ion-text class="font-text font-text--large">
        {{ authQuery.nome$ | async }} </ion-text><br>
      <ion-text class="description-text description-text--medium">
        {{ (authQuery.cpf$ | async) | mask: '000.000.000-00' }}
      </ion-text>
    </ion-label>
    <ion-icon (click)="close()" icon="close-outline" class="icon ion-padding-horizontal ion-activatable ripple-parent"
      text="fechar" color="medium" name="close-outline">
    </ion-icon>
  </ion-item>
</ion-header>
